import { useEffect, useState } from "react";
import axios from "axios";
import styles from "./Team.module.css";
import guestii_gif from '../../assets/images/guestii_gif.gif'

/* 
  Example of importing your helper components. 
  Adjust the paths to match your project's structure.
*/
import { 
  MovingTextContainer, 
  MovingTagContainer 
} from "../Utils/Helpers";

/** 
 * Main multi-step component 
 */
const NewTeamMember = ({ tempFormData = null, handleOpen }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [formData, setFormData] = useState({});
  const [newAddress, setNewAddress] = useState(null);
  const [selected, setSelected] = useState([]);
  const [validationError, setValidationError] = useState(null)

  useEffect(() => {
    const handleLoad = async () => {
      if (tempFormData) {
        setFormData({ ...tempFormData, edit: true });
      }
    };
    handleLoad();
  }, [tempFormData]);

  const handleForm = async (control, label, input) => {
    switch (control) {
      case "set": {
        const labelFormatted = label.replaceAll(" ", "_").toLowerCase();

        if (input.target) {
          setFormData((prev) => ({
            ...prev,
            [labelFormatted]: input.target.value,
          }));
        } else {
          setFormData((prev) => ({
            ...prev,
            [labelFormatted]: input,
          }));
        }
        break;
      }
      case "submit": {
        const userId = localStorage.getItem("_id")
        if (!userId) {
          window.location = "/connect"
        }

        try {
          setIsLoading(true)
          await axios.post(`/api/team/create-team-member/${userId}`, {
            general: formData
          });

          window.location.reload()
          setIsLoading(false)
        } catch (e) {
          if (e.response && e.response && e.response.data && e.response.data.duplicate) {
            setValidationError(e.response.data.message)
            setIsLoading(false)
            return false;
          } else {
            localStorage.removeItem("_id")
            window.location = "/connect"
          }
        }
        break;
      }
      default:
        break;
    }
  };

  return (
    <NewEventPage
      formData={formData}
      handleForm={handleForm}
      newAddress={newAddress}
      setSelected={setSelected}
      selected={selected}
      handleOpen={handleOpen}
      isLoading={isLoading}
      validationError={validationError}
      setValidationError={setValidationError}
    />
  );
};

export default NewTeamMember;


const NewEventPage = ({
  formData,
  handleForm,
  newAddress,
  setSelected,
  selected,
  handleOpen,
  isLoading,
  validationError,
  setValidationError
}) => {
	const [page, setPage] = useState(1);

  useEffect(() => {
    const handleLoad = async () => {
      if (formData && formData.hasOwnProperty('edit') && formData.edit) {
        setPage(2)
      }
    };
    handleLoad();
  }, [formData]);

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

	const pageValidator = (checks) => {
		let checked = []

		for (const check of checks) {
			const input = check.input
			const label = check.label
			const condition = check.condition
			const formValue = formData[input]

			switch (condition) {
				case 'isSet':
				case 'isChecked':
          if (label === "email") {
            if (isValidEmail(formValue)) {
              checked.push({
                input: input,
                success: true
              })
            } else {
              checked.push({
                input: input,
                success: false,
                msg: `Please enter a valid ${label}.`
              })
            }
          }

					if (formValue && formValue !== "") {
						checked.push({
							input: input,
							success: true
						})
					} else {
						checked.push({
							input: input,
							success: false,
							msg: `Please ${condition === "isSet" ? "enter" : "select"} the ${label}.`
						})
					}
			}
		}

		return checked
	}

	const handleControls = (control) => {
  	switch (control) {
    	case "next":
        var checks = [
            {
              input: 'role', 
              label: 'role',
              condition: 'isChecked'
            }
        ]

  			var checked = pageValidator(checks)
  			var errors = checked.filter(check => !check.success)

  			if (errors.length > 0) {
  				setValidationError(errors[0].msg)
  			} else {
  				setValidationError(null)
  				setPage(page + 1);
  			}

      	break;
    	case "prev":
      	setPage(page - 1);
      	break;
    	case "submit":
        var checks = [
          {
            input: 'first_name', 
            label: 'first name',
            condition: 'isSet'
          },
          {
            input: 'last_name', 
            label: 'last name',
            condition: 'isSet'
          },
          {
            input: 'email', 
            label: 'email',
            condition: 'isSet'
          }
        ]

  			var checked = pageValidator(checks)
  			var errors = checked.filter(check => !check.success)

  			if (errors.length > 0) {
  				setValidationError(errors[0].msg)
  			} else {
  				setValidationError(null)
  				handleForm("submit");
  			}

      	break;
    	default:
      	break;
  	}
	};

  return (
    <div className={styles.popup_container}>
      {!isLoading
        ?
          <div className={styles.new_layout}>
            <button className={styles.ind_close} onClick={() => handleOpen('close')}><i className={`fa-solid fa-xmark ${styles.s1}`}></i></button>

            <div className={styles.new_banner}>
              <div className={styles.new_title}>
                {page === 1
                  ? <p className={styles.bold}>Set Team Member Role</p>
                  : <p className={styles.bold}>Create New Team Member</p>
                }
                <p className={styles.s1}>Use this module to manage your team</p>
              </div>

              {/* Progress Bar */}
              <div className={styles.banner_progress} 
                /* changed to 2 columns for 2 steps */
                style={{ gridTemplateColumns: "repeat(2, 1fr)" }}
              >
                {/* Step 1: Info */}
                <div
                  className={`${styles.progress_circle} ${
                    page >= 1 && styles.progress_circle_active
                  }`}
                >
                  <i className={`fa-solid fa-info ${styles.m1}`}></i>
                </div>
                {/* Step 2: Role */}
                {(!formData['edit']) &&
                  <div
                    className={`${styles.progress_circle} ${
                      page >= 2 && styles.progress_circle_active
                    }`}
                  >
                    <i className={`fa-solid fa-user-shield ${styles.m1}`}></i>
                  </div>
                }
              </div>
            </div>

            {/* Page 1: Basic Info */}
            {(page === 1 && !formData['edit']) && <RolePage formData={formData} handleForm={handleForm} />}

            {page === 2 && (
              <InfoPage formData={formData} handleForm={handleForm} newAddress={newAddress} />
            )}

            {validationError && <div className={styles.errorMsg}><p className={styles.s1}>{validationError}</p></div>}

            <FormControls page={page} handleControls={handleControls} formData={formData}/>
          </div>
        :
          <div className={styles.loading_layout}>
            <img src={guestii_gif}/>
          </div>
      }
    </div>
  );
};

/** 
 * Page 1: Basic Info
 */
const InfoPage = ({ formData, handleForm, newAddress }) => {
  return (
    <div className={styles.nevent_form_container}>
      <div className={styles.nevent_double}>
        <MovingTextContainer
          label={"First name"}
          icon={"fa-solid fa-address-card"}
          handleForm={handleForm}
          formData={formData}
        />
        <MovingTextContainer
          label={"Last name"}
          icon={"fa-solid fa-address-card"}
          handleForm={handleForm}
          formData={formData}
        />
      </div>

      <MovingTextContainer
        label={"Email"}
        icon={"fa-solid fa-envelope"}
        handleForm={handleForm}
        formData={formData}
      />
    </div>
  );
};

/** 
 * Page 2: Role Selection
 * ( SuperAdmin / EventManager / Scanner )
 */
const RolePage = ({ formData, handleForm }) => {
  const roles = [
    {
      label: "Account Owner",
      value: "SuperAdmin",
      description: "Has the same permissions as the account owner",
    },
    {
      label: "Event Manager",
      value: "Event Manager",
      description: "Has complete control over selected events",
    },
    {
      label: "Promoter",
      value: "Promoter",
      description: "Has control over a limit of people for selected events",
    },
    {
      label: "Scanner",
      value: "Scanner",
      description: "Limited access – can only scan tickets",
    },
  ];

  const handleRoleSelect = (role) => {
    handleForm("set", "Role", { target: { value: role } });
  };

  return (
    <div className={styles.nevent_form_container}>
      <div className={styles.roles_container}>
        {roles.map((r) => (
          <div
            key={r.value}
            className={`${styles.role_item} ${
              formData.role === r.value ? styles.active_role : ""
            }`}
            onClick={() => handleRoleSelect(r.value)}
          >
            <p className={styles.role_label}>{r.label}</p>
            <p className={styles.s1}>{r.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

/** 
 * Bottom Buttons: Next / Back / Submit
 */
const FormControls = ({ page, handleControls, formData }) => {
  return (
    <div className={styles.control_container}>

      {((formData['edit']) && page === 2) &&
        <button
          className={`${styles.control_btn} ${styles.next_btn}`}
          onClick={() => handleControls("submit")}
        >
          <i className={`fa-solid fa-check ${styles.m1}`}></i>
        </button>
      }

      {(page === 1 && !formData['edit']) && (
        <button
          className={`${styles.control_btn} ${styles.next_btn}`}
          onClick={() => handleControls("next")}
        >
          <i className={`fa-solid fa-arrow-right ${styles.m1}`}></i>
        </button>
      )}

      {(page === 2 && !formData['edit']) && (
        <div style={{ marginLeft: "auto", display: "flex", gap: "1rem" }}>
          <button
            className={styles.control_btn}
            onClick={() => handleControls("prev")}
          >
            <i className={`fa-solid fa-arrow-left ${styles.m1}`}></i>
          </button>
          <button
            className={styles.control_btn}
            onClick={() => handleControls("submit")}
          >
            <i className={`fa-solid fa-check ${styles.m1}`}></i>
          </button>
        </div>
      )}
    </div>
  );
};

/** 
 * Dummy placeholders to avoid reference errors:
 */
function Loading() {
  return <div>Loading...</div>;
}

function Forbidden() {
  return <div>Forbidden</div>;
}
